import { render, staticRenderFns } from "./entrepreneurialIndicators.vue?vue&type=template&id=053d13f2&scoped=true"
import script from "./entrepreneurialIndicators.vue?vue&type=script&lang=js"
export * from "./entrepreneurialIndicators.vue?vue&type=script&lang=js"
import style0 from "./entrepreneurialIndicators.vue?vue&type=style&index=0&id=053d13f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053d13f2",
  null
  
)

export default component.exports